<template>
  <div class="microchip-form__container">
    <FormTitle title="Заповніть дані про мікрочип/татуювання" />
    <div class="microchip-form__fields">
      <div class="microchip-form__field-row">
        <TextInput
          class="microchip-form__field"
          placeholder="Код мікрочіпа *"
          :limit="25"
          v-model="microchip.code"
          :error-messages="getValidationErrors('microchip.code', {
            required: 'Введіть код мікрочіпа',
            validMicrochipCode: 'Код мікрочіпа має бути від 10 до 25 символів',
          })"
          @change="$emit('changeMicrochipCode', $event)"
          @blur="touchField('microchip.code')"
        />
        <DateInput
          class="microchip-form__field"
          placeholder="Дата чіпування *"
          format="DD.MM.YYYY"
          type="input"
          :disabled-future-dates="true"
          v-model="microchip.date"
          :error-messages="getValidationErrors('microchip.date', {
            required: 'Введіть дату чіпування',
          })"
          @change="$emit('changeMicrochipDate', $event)"
          @blur="touchField('microchip.date')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { ValidateForm } from '@/shared/lib/form';
import { PetValidation } from '@/shared/lib/insurance';
import { DateInput, FormTitle, TextInput } from '@/shared/ui/form';

const { validMicrochipCode } = PetValidation();

export default {
  props: {
    initialMicrochipCode: {
      type: String,
      default: null,
    },
    initialMicrochipDate: {
      type: [String, Date],
      default: null,
    },
  },
  data() {
    return {
      microchip: {
        code: this.initialMicrochipCode,
        date: this.initialMicrochipDate,
      },
    };
  },
  validations() {
    return {
      microchip: {
        code: {
          required,
          validMicrochipCode,
        },
        date: {
          required,
        },
      },
    };
  },
  mixins: [ValidateForm],
  components: { FormTitle, TextInput, DateInput },
  watch: {
    initialMicrochipCode(newValue) {
      this.microchip.code = newValue;
    },
    initialMicrochipDate(newValue) {
      this.microchip.date = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.microchip-form {
  &__container {
    margin-bottom: 24px;
  }
  &__fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  &__field-row {
    display: flex;
    gap: 24px;
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }
  }
  &__field {
    flex: 1;
  }
}
</style>
